/* eslint-disable camelcase */
import React from "react"
import { auditShape } from "utils/propTypeShapes"
import { AuditedUser } from "shared/audits"

const ConversationClosedAuditItemDetails = ({ audit }) => {
  const { conversation } = audit
  const { title } = conversation

  return (
    <div>
      <span>
        <AuditedUser audit={audit} /> closed the
        conversation titled <span className="font-semibold">{title}</span>.
      </span>
    </div>
  )
}

ConversationClosedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default ConversationClosedAuditItemDetails
